import styled from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../common/responsive';

const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  font-family: 'Inter', sans-serif;
  height: fit-content;
  margin-top: -10px;
  margin-bottom: -10px;
  color: ${({ theme }) => theme.text.regular};
  @media ${PHONE_MEDIA_QUERY} {
    margin-top: -5px;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  height: fit-content;
  @media ${PHONE_MEDIA_QUERY} {
    border-spacing: 0px 5px;
  }
`;

const Tr = styled.tr`
  @media (hover: hover) {
    &:hover {
      background: ${({ theme }) => theme.background.light};
    }
  }
  cursor: pointer;
  @media ${PHONE_MEDIA_QUERY} {
    td {
      background: ${({ theme }) => theme.background.secondary};
    }
  }
`;

const Td = styled.td`
  padding: 12px;
  vertical-align: middle;
  border-bottom: 1px solid ${({ theme }) => theme.border.secondary};
  @media ${PHONE_MEDIA_QUERY} {
    border-bottom: none;
    &:first-child {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }
    &:last-child {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
`;

const Tbody = styled.tbody``;

export { TableContainer, Table, Tr, Td, Tbody };
